module.exports = __webpack_public_path__ + "img/E7.f2fa1b73.svg";